export const GET_LIST_BANK = 'GET_LIST_BANK';
export const GET_LIST_BANK_DONE = 'GET_LIST_BANK_DONE';
export const GET_INFO_CUSTOMER_PAYMENT = 'GET_INFO_CUSTOMER_PAYMENT';
export const GET_INFO_CUSTOMER_PAYMENT_DONE = 'GET_INFO_CUSTOMER_PAYMENT_DONE';
export const GET_LIST_BANK_BRANCH = 'GET_LIST_BANK_BRANCH';
export const GET_LIST_BANK_BRANCH_DONE = 'GET_LIST_BANK_BRANCH_DONE';

export const CREATE_INFO_CUSTOMER_PAYMENT = 'CREATE_INFO_CUSTOMER_PAYMENT';